import React from 'react'
import img1 from './../../Photo/Shopicon.png'
import { BsCartPlusFill } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import { cartCount } from './Med'

const ShopHeader = () => {

  const navigate = useNavigate();

  const go = () => {
    navigate('/cart')
  }

  return (
    <nav class="navbar navbar-light bg-primary">
      <div className='navimg'>
        <img src={img1} width="30" height="30" alt="" />
      </div>
      <div class="navbar-brand shopnav" >
        Shopping App
      </div>
      <div className='navcart'>
        <BsCartPlusFill onClick={go} size={20} />
        {cartCount()}
      </div>
    </nav>
  )
}

export default ShopHeader